// src/admin/components/SectionSettingsPage.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../../common/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore/lite';
import SectionList from './SectionList';
import '../styles/SectionSettings.css';

// 기본 섹션 키 목록
const DEFAULT_KEYS = [
  'nav','main','service','how','about','gallery','contact','footer',
];

export default function SectionSettingsPage() {
  const [visible, setVisible] = useState([]);
  const [order, setOrder] = useState(DEFAULT_KEYS);
  const [hoverIdx, setHoverIdx] = useState(null);

  // 설정 불러오기
  useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'config', 'settings'));
        const cfg  = snap.exists() ? snap.data() : {};
        setVisible(cfg.visibleSections || DEFAULT_KEYS);
        setOrder(cfg.order           || DEFAULT_KEYS);
      } catch (err) {
        console.error('Config Fetch Error ▶', err);
        alert('⚠️ 설정 로드 오류');
      }
    })();
  }, []);

  // 보임 토글
  const toggle = key =>
    setVisible(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );

  // 순서 이동
  const moveItem = (from, to) =>
    setOrder(prev => {
      const next = [...prev];
      const [mv] = next.splice(from, 1);
      next.splice(to, 0, mv);
      return next;
    });

  // 저장
  const save = async () => {
    try {
      await setDoc(doc(db, 'config', 'settings'), {
        order,
        visibleSections: visible,
      });
      alert('✅ 저장 완료');
    } catch (err) {
      console.error('🔥 config 저장 에러 ▶', err);
      alert(`⚠️ 저장 실패: ${err.code}`);
    }
  };

  return (
    <section className="admin-wrap">
      <div className="admin-header">
        <h2>랜딩페이지 섹션 설정</h2>
      </div>

      <SectionList
        order={order}
        visible={visible}
        toggle={toggle}
        onMoveItem={moveItem}
        hoverIdx={hoverIdx}
        setHoverIdx={setHoverIdx}
      />

      <button className="save-btn" onClick={save}>
        저장
      </button>
    </section>
  );
}
